import type { SupabaseClient } from '@supabase/supabase-js'
import { supabase } from '@quoter/web-core'
import type { ProductDatabase } from './db-types'

/**
 * LowFodmaps's tables. The shared client is typed for the platform's `public`
 * schema; this is the same client (same session, same connection) pointed at
 * this product's schema and typed for it. Platform tables stay on `supabase`.
 */
export const db = (supabase as unknown as SupabaseClient<ProductDatabase>).schema('p_lowfodmaps')
